import React from "react";
import "./Footer.css";
import img from "../../img/img.png";
import { Button, Col, Form } from "react-bootstrap";
const Footer = () => {
  return (
    <div>
      <div className="news-latter ">
        <div className="container d-flex justify-content-center px-5  text-white">
          <h3 className="px-5">SIGN UP FOR NEWSLATTER</h3>
          <div className="px-5 flex-grow-1 d-flex g-4">
            <Form.Group as={Col} className="" controlId="formGridEmail">
              <Form.Control
                className="email-field w-60 shadow-none"
                type="email"
                placeholder="Enter email"
              />
            </Form.Group>
            <Button variant="btn btn-outline-light ms-4">Submit</Button>
          </div>
        </div>
      </div>
      <section className=" footer  footer-bg p-5 d-flex align-items-center justify-content-between">
        <div className="col-lg-6">
          <div className=" footer ps-5 ms-5">
            <a className="me-5 " href="/">
              Terms of Service
            </a>
            <a href="/">License</a>
          </div>
          <div className=" footer pt-3 ps-5 ms-5">
            <a className="me-3" href="/">
              Privacy Policy
            </a>
            <a className="me-3" href="/">
              FAQs
            </a>
            <a className="me-3" href="/">
              Sitemap
            </a>
            <a href="/">Feedback</a>
          </div>
          <div>
            <p className="me-3 pt-5 pb-5 text-white ps-5 ms-5">
              <a href="/">© Developed By Muhammad Nurul Ahsan</a>
            </p>
          </div>
        </div>
        <div className="col-lg-6">
          <img className="img-fluid mx-auto ps-5 ms-5" src={img} alt="" />
        </div>
      </section>
      <div className="footer-text text-white">
        <h6>© 2021 All Rights Reserved.</h6>
      </div>
    </div>
  );
};

export default Footer;
